import { Quitus, QuitusStatus, useGetQuitusesMutation } from '@services';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useQuitusPageVM = () => {
    const [quituses, setQuituses] = useState<Quitus[]>([]);
    const navigate = useNavigate();

    const [getQuituses, { isLoading: isLoadingQuituses, data: quitusesData, isError: isErrorQuituses }] = useGetQuitusesMutation();

    useEffect(() => {
        getQuituses();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isLoadingQuituses) {
            return;
        }

        if (quitusesData) {
            setQuituses(quitusesData);
        }
    }, [isLoadingQuituses, quitusesData]);

    const waitingQuituses = useMemo(() => quituses.filter((quitus) => quitus.status !== QuitusStatus.ARCHIVED), [quituses]);
    const validatedQuituses = useMemo(() => quituses.filter((quitus) => quitus.status === QuitusStatus.ARCHIVED), [quituses]);

    return { waitingQuituses, validatedQuituses, isLoadingQuituses, isErrorQuituses, navigate };
};
